import { AgGridReact } from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-material.css';
import { useAgGrid } from '@tassat/ag-grid';
import { isEqual } from 'lodash';
import React from 'react';

import { AG_GRID_SMALL_HEADER_HEIGHT } from 'Lib/constant';
import AddressCellRenderer from 'SharedComponents/cellRenderComponent/AddressCellRenderer';
import IsPrimaryCellRenderer from 'SharedComponents/cellRenderComponent/isPrimaryCellRenderer';
import WalletNameCellRenderer from 'SharedComponents/cellRenderComponent/walletNameCellRenderer';

import { readonlyFirmAccountWalletsColumnDefs } from './gridOptions';

import type { FirmWalletsGridProps } from '.';

import 'SharedComponents/agGrid/styles/agGridOverrides.css';

export function FirmWalletsAgGrid (props: FirmWalletsGridProps) {
    const { wallets } = props;

    const [ rowData, setRowData ] = React.useState(wallets);
    const [ gridApi, onGridReady ] = useAgGrid();
    const shownRows = gridApi && gridApi.api.getRenderedNodes();

    React.useEffect(() => {
        if (rowData && !isEqual(rowData, wallets)) {
            setRowData(wallets);
        }
    }, [wallets]);

    const columnDefs = React.useMemo(() => {
        return readonlyFirmAccountWalletsColumnDefs;
    }, [wallets]);

    React.useEffect(() => {
        refreshHeaders();
    }, [ rowData, shownRows ]);

    const refreshHeaders = () => {
        if (gridApi) {
            gridApi.api.refreshHeader();
        }
    };

    return (
        <div
            className='ag-theme-material'
            id='firmWalletUsersGrid'
            style={{ height: '100%' }}
        >
            <AgGridReact
                animateRows={false}
                columnDefs={columnDefs}
                columnMenu='legacy'
                components={{
                    walletNameCellRenderer: WalletNameCellRenderer,
                    addressCellRenderer: AddressCellRenderer,
                    isPrimaryCellRenderer: IsPrimaryCellRenderer
                }}
                defaultColDef={{
                    resizable: true,
                    filter: true,
                    sortable: true
                }}
                enableCellTextSelection={true}
                headerHeight={AG_GRID_SMALL_HEADER_HEIGHT}
                onFilterChanged={refreshHeaders}
                onGridReady={onGridReady}
                rowData={rowData}
                suppressCellFocus={true}
                suppressContextMenu={true}
            />
        </div>
    );
}